"use client"

import { useEffect } from "react"
import { setUploadHandler } from "@/lib/upload/upload-bridge"
import { useUpload } from "@/lib/upload/use-upload"

export default function UploadHandlerRegister() {
  const { handleUpload } = useUpload()

  useEffect(() => {
    setUploadHandler(handleUpload)
  }, [handleUpload])

  return null
}